import axios from "axios";

export const getAgentMembers = async (teamId) => {
  return fetch(
    `https://pensionhub.nlpcpfa.com:8445/api/onboarding/api/TeamsManagement/agent/getAll?TeamId=${teamId}&PageSize=1000&PageNumber=1`
  )
    .then((response) => response.json())
    .then((data) => data.result)
    .catch((error) => {
      console.error("Error fetching team members:", error);
      return [];
    });
};
export const getTeamMembers = async () => {
  const data = await axios.get(
    `https://pensionhub.nlpcpfa.com:8445/api/onboarding/api/OnboardingSetup/Teams/GetAll?PageSize=1000&PageNumber=1`
  );
  return data.data.result;
};
